import { createError } from '@common/neo.tax';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { GetCompanyQuery } from '../graphql';
import { useCompany } from './useCompany';
import { useCurrentCompanyId } from './useCurrentCompanyId';

export const useCurrentCompany = (): ReturnType<typeof useCompany> => {
  const companyId = useCurrentCompanyId();
  const useCompanyResult = useCompany({ companyId });
  const { company } = useCompanyResult;

  useEffect(() => {
    if (company?.shortName && company?.id) {
      // TODO encapsulate the error logger
      // set the company info for all following Sentry events
      Sentry.setTag('company-name', company.shortName);
      Sentry.setTag('company-id', company.id);
    }
  }, [company?.shortName, company?.id]);

  return useCompanyResult;
};

export const useCurrentCompanyOrFail = (): GetCompanyQuery['getCompany'] => {
  const { company } = useCurrentCompany();
  if (!company) {
    throw createError(
      'CompanyNotLoaded',
      'Company not loaded when the component is rendered. Add waiting on the above hook to the route loader guard.',
    );
  }
  return company;
};
